import { TheMask } from 'vue-the-mask'

export default {
  TheMask
}



// WEBPACK FOOTER //
// ./src/app/tenant/livings/resources/components.js